import type { IdTokenClaims } from 'oidc-client-ts'

export type ProfileClaims = {
  organizationId: string | undefined
  userEntityId: string | undefined
}

// Keycloak mappers may emit claims in snake_case or camelCase
export const extractProfileClaims = (profile: IdTokenClaims): ProfileClaims => ({
  organizationId: (profile.organization_id ?? profile.organizationId) as string | undefined,
  userEntityId: (profile.user_entity_id ?? profile.userEntityId) as string | undefined,
})
